import { render, staticRenderFns } from "./AddSortSettings.vue?vue&type=template&id=eb6ac146"
import script from "./AddSortSettings.vue?vue&type=script&lang=ts"
export * from "./AddSortSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports